/**
 * 图片函数
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/26      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

/**
 * 读取指定尺寸的图片地址，并且指定图片是否模糊处理
 * @param url   原图地址
 * @param size  图片展示尺寸（80，200）
 * @param fuzzy 是否模糊图片
 */
function loadImage(url, size = 200, fuzzy) {
    // 预定义尺寸：具体的预定义尺寸，请查阅OSS所配置的尺寸
    const SizeMap = [80, 100, 200, 600];

    // 模糊效果改为样式控制，这里先屏蔽
    /*if (fuzzy) {
        // 模糊范围
        const h = Math.ceil(size / 3);
        const index = String(url).lastIndexOf("/");
        const picName = String(url).substring(index + 1, url.length);
        // const watermark = `${picName}?x-oss-process=image/resize,w_${size},h_${size},m_pad/crop,g_west,h_${h}/blur,r_20,s_50/bright,40`;
        const watermark = `${picName}?x-oss-process=image/resize,w_${size},h_${size},m_pad/blur,r_50,s_50/bright,-30`;
        const base64WaterMark = getBase64(watermark, true);
        return `${url}?x-oss-process=image/resize,w_${size},h_${size},m_pad/watermark,image_${base64WaterMark},g_center`;
        // return `${url}@!${size}${fuzzy ? '_b': ''}`;
    } else */

    if(url){
        const array = url.split("@!");
        url = array[0];
    }
    if (SizeMap.indexOf(size) > -1) {
        if(size==200){
            return `${url}@!webp_300_q80`;
        }
        return `${url}@!${size}`;
    } else {
        return `${url}?x-oss-process=image/resize,w_${size},h_${size},m_pad/quality,q_80/format,webp`;
    }
}

export {
    loadImage
};
